<div class="shipment-packages-form" [formGroup]="formGroup">
  <div class="flex flex-col md:flex-row mx-2">
      @if (displayDocumentsOnly$ | async) {
          <mat-checkbox color="primary" formControlName="documentsOnly">Documents Only</mat-checkbox>
          <mat-checkbox color="primary" [checked]="insurance$ | async" (change)="changeInsurance($event)">Insurance</mat-checkbox>
      }
      @if (displayLtlOptions$ | async) {
          <mat-checkbox [checked]="hazardousMaterials$ | async" (change)="setHazardousMaterials($event.checked)">Hazardous Materials</mat-checkbox>
      }
    <span class="grow"></span>
      @if (displayPackagingTypes$ | async) {
          <button mat-button [matMenuTriggerFor]="packagingMenu">{{ currentPackagingLabel$ | async }}</button>
          <mat-menu #packagingMenu>
              @for (pkgType of packagingTypes$ | async; track pkgType) {
                  <button [value]="pkgType.code" mat-menu-item (click)="changePackagingType(pkgType.code)">{{ pkgType.caption }}</button>
              }
          </mat-menu>
      }
      @if (displayLtlOptions$ | async) {
          <button mat-button [matMenuTriggerFor]="reeferMenu">{{ truckTypeDisplay$ | async }}</button>
          <mat-menu #reeferMenu>
              <button mat-menu-item (click)="setRefrigeratedTruck(false)" i18n>Dry LTL</button>
              <button mat-menu-item (click)="setRefrigeratedTruck(true)" i18n>Reefer</button>
          </mat-menu>
      }
    <div class="flex flex-row justify-center">
      <button mat-button [matMenuTriggerFor]="packagingUnits">{{ currentUnitLabel$ | async }}</button>
      <mat-menu #packagingUnits>
        <button mat-menu-item (click)="changeUnits('LB')">Imperial</button>
        <button mat-menu-item (click)="changeUnits('KG')">Metric</button>
      </mat-menu>
      <button mat-button [matMenuTriggerFor]="currency">{{ currentCurrency$ | async }}</button>
      <mat-menu #currency>
        <button mat-menu-item (click)="changeCurrency('CAD')">CAD</button>
        <button mat-menu-item (click)="changeCurrency('USD')">USD</button>
        <button mat-menu-item (click)="changeCurrency('EUR')">EUR</button>
        <button mat-menu-item (click)="changeCurrency('GBP')">GBP</button>
      </mat-menu>
    </div>
  </div>

    <div class="px-4">
        <app-shipment-packages-table></app-shipment-packages-table>
    </div>

    <div class="flex flex-col" formArrayName="packages">
      <!--
    @for (pkg of shipmentPackages$ | async; track trackPackage(pkgIndex, pkg); let pkgIndex = $index) {
      <ng-container [formGroupName]="pkgIndex">
        <div class="flex flex-col pt-2">
          <div class="flex flex-row flex-auto mx-2">
            <div class="flex flex-none w-10">
              <button matIconButton class="glyph-button">
                <app-icon [number]="pkgIndex + 1" numberType="circle"></app-icon>
              </button>
              <span class="package-number" i18n-matTooltip matTooltip="Package {{ pkgIndex + 1 }}">{{ pkgIndex + 1 }}</span>
            </div>
            @if (!pkg.templateId) {
              <div class="flex package-container flex-col grow">
                <div class="flex flex-col md:flex-row flex-grow gap-2">
                  <div class="flex flex-col sm:flex-row grow gap-2">
                    <mat-form-field class="flex-none numeric w-full sm:w-16" floatLabel="always">
                      <mat-label i18n>Qty</mat-label>
                      <input matInput formControlName="quantity" class="numeric" type="number" min="1">
                    </mat-form-field>
                    <mat-form-field class="w-full grow sm:w-24" floatLabel="always">
                      <mat-label i18n>Description</mat-label>
                      <input matInput formControlName="description">
                    </mat-form-field>
                      <mat-form-field class="w-full sm:flex-none sm:w-40" floatLabel="always">
                          <mat-label i18n>Packaging</mat-label>
                          <mat-select formControlName="packageCode">
                              <mat-option value="PALLET">Pallet</mat-option>
                              <mat-option value="BOX">Box</mat-option>
                              <mat-option value="BUNDLE">Bundle</mat-option>
                              <mat-option value="CARTON">Carton</mat-option>
                              <mat-option value="DRUM">Drum</mat-option>
                              <mat-option value="ROLL">Roll</mat-option>
                              <mat-option value="CASE">Case</mat-option>
                              <mat-option value="SKID">Skid</mat-option>
                              <mat-option value="COIL">Coil</mat-option>
                              <mat-option value="TUBE">Tube</mat-option>
                              <mat-option value="PIPE">Pipe</mat-option>
                              <mat-option value="BAG">Bag</mat-option>
                              <mat-option value="PAIL">Pail</mat-option>
                              <mat-option value="REEL">Reel</mat-option>
                              <mat-option value="CYLINDER">Cylinder</mat-option>
                              <mat-option value="TOTES">Totes</mat-option>
                              <mat-option value="UNITS">Units</mat-option>
                          </mat-select>
                      </mat-form-field>
                    <mat-form-field class="w-full sm:flex-none numeric sm:w-20" floatLabel="always">
                      <mat-label i18n>Weight</mat-label>
                      <input matInput formControlName="weight" class="numeric">
                      @if (isMetric()) {
                        <span matTextSuffix class="units" i18n>kgs</span>
                      }
                      @if (!isMetric()) {
                        <span matTextSuffix class="units" i18n>lbs</span>
                      }
                    </mat-form-field>
                  </div>
                  <div class="flex flex-col sm:flex-row grow md:flex-none gap-2">
                    <mat-form-field class="w-full sm:w-20 grow md:flex-none numeric" floatLabel="always">
                      <mat-label i18n>Length</mat-label>
                      <input matInput formControlName="length" class="numeric">
                      @if (isMetric()) {
                        <span matTextSuffix class="units" i18n>cm</span>
                      }
                      @if (!isMetric()) {
                        <span matTextSuffix class="units" i18n>"</span>
                      }
                    </mat-form-field>
                    <mat-form-field class="w-full sm:w-20 grow md:flex-none numeric" floatLabel="always">
                      <mat-label i18n>Width</mat-label>
                      <input matInput formControlName="width" class="numeric">
                      @if (isMetric()) {
                        <span matTextSuffix class="units" i18n>cm</span>
                      }
                      @if (!isMetric()) {
                        <span matTextSuffix class="units" i18n>"</span>
                      }
                    </mat-form-field>
                    <mat-form-field class="w-full sm:w-20 grow md:flex-none numeric" floatLabel="always">
                      <mat-label i18n>Height</mat-label>
                      <input matInput formControlName="height" class="numeric">
                      @if (isMetric()) {
                        <span matTextSuffix class="units" i18n>cm</span>
                      }
                      @if (!isMetric()) {
                        <span matTextSuffix class="units" i18n>"</span>
                      }
                    </mat-form-field>
                    @if (insurance$ | async) {
                      <mat-form-field class="w-full sm:w-20 grow md:flex-none numeric" floatLabel="always">
                        <mat-label i18n>Insurance</mat-label>
                        <input matInput formControlName="value" class="numeric">
                        <span matTextPrefix class="units">{{ currencyPrefix() }}</span>
                      </mat-form-field>
                    }
                  </div>
                </div>
              </div>
            }
            @if (!!pkg.templateId) {
              <div class="flex package-container flex-col grow">
                <div class="flex flex-row flex-grow gap-2">
                  <div class="flex flex-col sm:flex-row grow gap-2">
                    <mat-form-field class="flex-none numeric w-full sm:w-16" floatLabel="always">
                      <mat-label i18n>Qty</mat-label>
                      <input matInput formControlName="quantity" class="numeric" type="number" min="1">
                    </mat-form-field>
                    <div class="flex flex-col sm:flex-wrap md:flex-row grow gap-4 mb-2">
                      <div class="information flex flex-col grow">
                        <div class="caption">Description</div>
                        <div class="property">{{ pkg.description }}</div>
                      </div>
                      <div class="information flex flex-col">
                        <div class="caption">Weight</div>
                        <div class="property">{{ pkg.weight | weight:(shipment$ | async).weightUnit }}</div>
                      </div>
                      <div class="information flex flex-col">
                        <div class="caption">Dimensions</div>
                        <div class="property">{{ [pkg.width, pkg.length, pkg.height] | dimensions:(shipment$ | async).dimensionUnit }}</div>
                      </div>
                      <div class="information flex flex-col">
                        <div class="caption">Insurance</div>
                        <div class="property">{{ pkg.value | currency:(shipment$ | async).currency }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="hidden md:flex">
                    <button matIconButton class="glyph-button" (click)="deTemplatePackage(pkgIndex)" matTooltip="Edit this package" i18n-matTooltip>
                      <app-icon icon="pen"></app-icon>
                    </button>
                  </div>
                </div>
              </div>
            }
            <div class="flex-none w-8 flex-col">
              <button matIconButton class="glyph-button" (click)="deletePackage(pkgIndex)" [disabled]="!canDeletePackage()" matTooltip="Delete this package from the shipment" i18n-matTooltip>
                <app-icon icon="delete"></app-icon>
              </button>
              <div class="block md:hidden">
                @if (!!pkg.templateId) {
                  <button matIconButton class="glyph-button" (click)="deTemplatePackage(pkgIndex)" matTooltip="Edit this package" i18n-matTooltip>
                    <app-icon icon="pen"></app-icon>
                  </button>
                }
              </div>
            </div>
          </div>
          @if (commodityEditor$ | async) {
            <div class="commodity-container">
              <div formArrayName="commodities">
                @for (com of pkg.commodities; track trackCommodity(comIndex, com); let comIndex = $index) {
                  <div>
                    <div [formGroupName]="comIndex" class="commodity-entry mr-2">
                      <div class="flex flex-row">
                        <div class="w-12">
                          <button matIconButton class="glyph-button">
                            <app-icon [number]="comIndex + 1" numberType="square"></app-icon>
                          </button>
                        </div>
                        @if (!com.templateId && !pkg.templateId) {
                          <div class="commodity-container flex flex-wrap md:flex-row grow gap-2">
                            <mat-form-field class="flex-auto w-16 md:flex-none" floatLabel="always">
                              <mat-label i18n>Qty</mat-label>
                              <input matInput formControlName="quantity">
                            </mat-form-field>
                            <mat-form-field class="flex-auto w-32 grow" floatLabel="always">
                              <mat-label i18n>Description</mat-label>
                              <input matInput formControlName="description">
                            </mat-form-field>
                            <mat-form-field class="flex-auto w-32 md:flex-none" floatLabel="always">
                              <mat-label i18n>HS Code</mat-label>
                              <input matInput formControlName="harmonizedCode">
                            </mat-form-field>
                            <mat-form-field class="flex-auto w-20 md:grow" floatLabel="always">
                              <mat-label i18n>Marks</mat-label>
                              <input matInput formControlName="markings">
                            </mat-form-field>
                            <app-country-field [control]="getCommodityCountryControl(pkgIndex, comIndex)" class="flex-auto w-32 md:flex-none"></app-country-field>
                            <mat-form-field class="flex-auto w-16 md:flex-none" floatLabel="always">
                              <mat-label i18n>U.O.M.</mat-label>
                              <input matInput formControlName="unitOfMeasure">
                            </mat-form-field>
                            <mat-form-field class="flex-auto w-20 md:flex-none" floatLabel="always">
                              <mat-label i18n>Price</mat-label>
                              <input matInput formControlName="price">
                            </mat-form-field>
                            <mat-form-field class="flex-auto w-20 md:flex-none" floatLabel="always">
                              <mat-label i18n>Weight</mat-label>
                              <input matInput formControlName="weight">
                            </mat-form-field>
                          </div>
                        }
                        @if (!!com.templateId || !!pkg.templateId) {
                          <div class="commodity-container flex flex-col sm:flex-row grow gap-2">
                            <div class="flex items-start grow w-full sm:w-16 flex-auto md:flex-none">
                              <mat-form-field class="w-full" floatLabel="always">
                                <mat-label i18n>Qty</mat-label>
                                <input matInput formControlName="quantity">
                              </mat-form-field>
                            </div>
                            <div class="flex flex-col sm:flex-wrap md:flex-row grow gap-4 justify-between">
                              <div class="information flex flex-col">
                                <div class="caption">Description</div>
                                <div class="property">{{ com.description }}</div>
                              </div>
                              <div class="information flex flex-col">
                                <div class="caption">HS Code</div>
                                <div class="property">{{ com.harmonizedCode }}</div>
                              </div>
                              <div class="information flex flex-col">
                                <div class="caption">Marks</div>
                                <div class="property">{{ com.markings }}</div>
                              </div>
                              <div class="information flex flex-col">
                                <div class="caption">Country Of Origin</div>
                                <div class="property">{{ com.country | countryName }}</div>
                              </div>
                              <div class="information flex flex-col">
                                <div class="caption">Unit of Measure</div>
                                <div class="property">{{ com.unitOfMeasure }}</div>
                              </div>
                              <div class="information flex flex-col">
                                <div class="caption">Price</div>
                                <div class="property">{{ com.price | currency:(shipment$ | async).currency }}</div>
                              </div>
                              <div class="information flex flex-col">
                                <div class="caption">Weight</div>
                                <div class="property">{{ com.weight | weight:(shipment$ | async).weightUnit }}</div>
                              </div>
                            </div>
                            <div class="hidden md:flex">
                              <button matIconButton class="glyph-button" (click)="deTemplateCommoditiesPackage(pkgIndex, comIndex)" matTooltip="Edit this commodity record" i18n-matTooltip>
                                <app-icon icon="pen"></app-icon>
                              </button>
                            </div>
                          </div>
                        }
                        <div class="flex-none w-8 flex-col">
                          <button matIconButton class="glyph-button" (click)="deleteCommodity(pkgIndex, comIndex)" [disabled]="!canDeleteCommodity(pkgIndex)">
                            <app-icon icon="delete"></app-icon>
                          </button>
                          <div class="block md:hidden ">
                            @if (!!com.templateId || !!pkg.templateId) {
                              <button matIconButton class="glyph-button" (click)="deTemplateCommoditiesPackage(pkgIndex, comIndex)" matTooltip="Edit this commodity record" i18n-matTooltip>
                                <app-icon icon="pen"></app-icon>
                              </button>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                <div class="flex justify-start -mt-6 mb-2">
                  <div class="commodity-number-container flex flex-none w-12">
                    <button matIconButton class="glyph-button" (click)="addCommodity(pkgIndex)">
                      <app-icon icon="square-plus"></app-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <mat-divider></mat-divider>
      </ng-container>
    }

    <div class="package-footer">
      <div class="flex flex-row package-summary mx-2">
        <div class="flex">
          <button matIconButton class="glyph-button" (click)="addPackage()">
            <app-icon icon="circle-plus"></app-icon>
          </button>
        </div>
        <div class="m-auto"></div>
        <div class="information p-2 pl-4">
          <div class="caption">Total Weight</div>
          <div class="property">
            <span [class.highlight]="!(dimensionalWeightGreater$ | async)">{{ totalActualWeight$ | async | number:'1.1-1' }}</span>
            @if (!isMetric()) {
              <span class="units" i18n> lbs</span>
            }
            @if (isMetric()) {
              <span class="units" i18n> kg</span>
            }
          </div>
        </div>
        @if ((totalDimensionalWeight$ | async) > 0) {
          <div class="information p-2" i18n-matTooltip matTooltip="Estimated Total Dimensional Weight for all the packages, rounded up using the common formula (which may vary for carriers)">
            <div class="caption" i18n>Dim. Weight</div>
            <div class="property">
              <span [class.highlight]="dimensionalWeightGreater$ | async">{{ totalDimensionalWeight$ | async | number:'1.1-1' }}</span>
              @if (!isMetric()) {
                <span class="units" i18n> lbs</span>
              }
              @if (isMetric()) {
                <span class="units" i18n> kg</span>
              }
            </div>
          </div>
        }
        @if ((totalInsurance$ | async) > 0) {
          <div class="information p-2">
            <div class="caption" i18n>Total Insurance</div>
            <div class="property">
              {{ currencyPrefix() }}
              {{ totalInsurance$ | async | number:'1.2-2' }}
            </div>
          </div>
        }
      </div>
    </div>
        -->
  </div>
</div>
